import headerDropDowns from 'header.dropdownmodule';
import headerAnalytics from 'header.analytics';
import headerData from 'header.data';
import utils from '../shared/utils';
import '../shared/sv-hover-intent';
import Mustache from 'mustache';

const headerDIYFlyout = {};

headerDIYFlyout.templates = {};

headerDIYFlyout.templates.diylist = headerDropDowns.templates.diyandhs;

headerDIYFlyout.getFlyoutData = function getFlyoutData() {
  const jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/diyflyout.json';
  const responseDataPromise = headerData.getEtchJSON(jsonPath);

  responseDataPromise.then(function _responseDataPromise(diyData) {
    const htmlContent = Mustache.render(headerDIYFlyout.templates.diylist, diyData.diyflyout);
    utils.setInnerHtml('.diyFlyout', htmlContent);
  });
};

// bind to all the necessary elements
headerDIYFlyout.initialize = function initialize() {
  if (headerData.isDropDown()) {
    utils.addListenersToAll(['click', 'touchend', 'hoverintent'], 
      '.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]', headerDIYFlyout.getFlyoutData);
    
    new SV.HoverIntent(document.querySelectorAll('.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]'), {
      onEnter: (targetItem) => {
        headerDIYFlyout.getFlyoutData();
      },
      onExit: () => { }
    })
    
    const events = ['click', 'touchend'];
    utils.delegateListeners(events, '#diyFlyout .content_image a', headerDIYFlyout.logInteractionforImg);
    utils.delegateListeners(events, '#diyFlyout .cta__text', headerDIYFlyout.logInteractionforL2);
    utils.delegateListeners(events, '#diyFlyout .diyFlyout__level3link', headerDIYFlyout.logInteractionforL3);
  }
}

headerDIYFlyout.logInteractionforL3 = function _logInteractionforL3(event) {
  const level2 = event?.target?.closest('.content')?.querySelector('.cta__text')?.textContent;
  const level3 = event?.target?.textContent.toLowerCase();
  return headerDIYFlyout.logEventPath('header click', [level2, level3]);
};

headerDIYFlyout.logInteractionforL2 = function _logInteractionforL2(event) {
  const level2 = event?.target?.textContent.toLowerCase();
  return headerDIYFlyout.logEventPath('header click', [level2]);
};

headerDIYFlyout.logInteractionforImg = function _logInteractionforImg(event) {
  const level2 = event?.target?.getAttribute('alt');
  return headerDIYFlyout.logEventPath('header click', [level2]);
};

headerDIYFlyout.logEventPath = function _logEventPath(type, pathArray) {
  // Get header at the beginning, then join them all
  const level1 = document.querySelector('.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]')?.textContent;
  return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
};

headerDIYFlyout.init = function init() {
  headerDIYFlyout.initialize();
  headerData.init();

  return this;
};

headerDIYFlyout.getPrivateMethods = () => headerDIYFlyout;

export default headerDIYFlyout;